import GreetingImage from "./GreetingImage";
export default GreetingImage;